import { Help } from '@plasma/ui.application.app';

const help: Help[] = [
  // {
  //   title: 'RawMaterialMaster',
  //   description: 'description of RawMaterialMaster',
  //   url: '/raw-material-master',
  // },
];

export default help;
